import React from 'react';
import './SubscriptionExpiryWarning.css';

interface SubscriptionWarningPopupProps {
    isOpen: boolean;
    onClose: () => void;
    currentPlanName: string;
    targetPlanName: string;
    warningType: 'downgrade' | 'same_plan';
}

const SubscriptionWarningPopup: React.FC<SubscriptionWarningPopupProps> = ({ 
    isOpen, 
    onClose, 
    currentPlanName, 
    targetPlanName, 
    warningType 
}) => {
    if (!isOpen) return null;

    return (
        <div className="sub-warning-overlay visible" onClick={onClose}>
            <div className="sub-warning-card visible" onClick={(e) => e.stopPropagation()}>
                <div className="sub-warning-icon">
                    <i className="fas fa-exclamation-triangle"></i>
                </div>
                <div className="sub-warning-content">
                    {warningType === 'downgrade' ? (
                        <>
                            <h2>PLAN DEĞİŞİKLİĞİ UYARISI</h2>
                            <p>
                                Şu anki paketiniz: <strong>{currentPlanName}</strong>
                            </p>
                            <p>
                                Geçmek istediğiniz paket: <strong>{targetPlanName}</strong>
                            </p>
                            <p style={{ color: '#e74c3c', marginTop: '10px' }}>
                                Daha düşük bir pakete geçmek üzeresiniz. Mevcut kullanım haklarınız ve süreniz etkilenebilir. 
                                Devam etmek için yeni paketin aktivasyon kodunu girmelisiniz.
                            </p>
                        </>
                    ) : (
                        <>
                            <h2>PAKET YENİLEME</h2>
                            <p>
                                Zaten aktif bir <strong>{currentPlanName}</strong> paketiniz bulunuyor.
                            </p>
                            <p>
                                Aynı paketi tekrar seçerek süresini uzatabilirsiniz. 
                                Ödeme onayından sonra iletilecek kodu kullanarak sürenizi güncelleyebilirsiniz.
                            </p>
                        </>
                    )}
                </div>
                <button className="sub-warning-btn" onClick={onClose}>
                    Anladım
                </button>
            </div>
        </div>
    );
};

export default SubscriptionWarningPopup;
